<template>
    <div>
        <div v-for="(rec, index) of data" :key="index" :class="{'yellow': rec === highlight}">{{ rec }}</div>
    </div>
</template>

<script>
  export default {
    name: "DataList",
    props: ['data', 'highlight'],
  }
</script>

<style scoped>

</style>
